var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectricianElectricity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00079 16.7498C7.93664 16.7499 6.88387 16.5309 5.90808 16.1063C4.93229 15.6818 4.05439 15.0608 3.32907 14.2821C2.60376 13.5035 2.04657 12.5838 1.69224 11.5803C1.33791 10.5769 1.19402 9.51128 1.26954 8.44981C1.53329 4.62856 4.62954 1.53231 8.45079 1.26856C9.51226 1.19304 10.5779 1.33693 11.5813 1.69127C12.5848 2.0456 13.5045 2.60278 14.2831 3.32809C15.0618 4.05341 15.6828 4.93131 16.1073 5.90711C16.5319 6.8829 16.7509 7.93567 16.7508 8.99981C16.7508 11.7573 15.4383 14.0454 13.4383 15.4042C11.5533 16.6873 9.00079 15.2792 9.00079 13.0011",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.25V11C6.25 11.5304 6.46071 12.0391 6.83579 12.4142C7.21086 12.7893 7.71957 13 8.25 13H9.75C10.2804 13 10.7891 12.7893 11.1642 12.4142C11.5393 12.0391 11.75 11.5304 11.75 11V8.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.25H6.75V5.125C6.75 4.95924 6.81585 4.80027 6.93306 4.68306C7.05027 4.56585 7.20924 4.5 7.375 4.5C7.54076 4.5 7.69973 4.56585 7.81694 4.68306C7.93415 4.80027 8 4.95924 8 5.125V8.25H10V5.125C10 4.95924 10.0658 4.80027 10.1831 4.68306C10.3003 4.56585 10.4592 4.5 10.625 4.5C10.7908 4.5 10.9497 4.56585 11.0669 4.68306C11.1842 4.80027 11.25 4.95924 11.25 5.125V8.25H12.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricianElectricity);
export default __webpack_public_path__ + "static/media/electrician-electricity.c31b8943.svg";
export { ForwardRef as ReactComponent };